var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductForm',{attrs:{"item":_vm.product,"type":_vm.type,"buttonLoading":_vm.buttonLoading},on:{"saveProduct":_vm.saveProduct}})}
var staticRenderFns = []

export { render, staticRenderFns }